import React from 'react';

function LuceFrame() {
  return (
    <div>
      <iframe src="https://app.fastsign.it/?appTitle=Greenia SRL&appBackgroundNumber=8" className="w-100" height={800} title="Greenia SRL Luce Gas" />
    </div>
  );
}

export default LuceFrame;
